// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import interceptorsSetup from './utils/interceptors'
import VueSweetalert2 from 'vue-sweetalert2'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import moment from 'vue-moment'
import VueLodash from 'vue-lodash'
import '@mdi/font/css/materialdesignicons.css'
import validateDe from 'vee-validate/dist/locale/de'
import VeeValidate, { Validator } from 'vee-validate'
import VueFuse from 'vue-fuse'
import de from './lang/de'
import it from './lang/it'
import Loader from './components/Formcomponents/Loader.vue'

window._ = require('lodash')

Validator.localize('de', validateDe)

interceptorsSetup()

store.commit('DETECT_LANGUAGE')

Vue.config.productionTip = false
Vue.use(VueSweetalert2)
Vue.use(Vuetify, {
  lang: {
    locales: { de, it },
    current: store.state.user.settings.language
  }})
Vue.use(moment)
Vue.use(VueLodash)
Vue.use(VeeValidate, { locale: store.state.user.settings.language })
Vue.use(VueFuse)
Vue.component('loader', Loader)

/* eslint-disable */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js